import http from '@/utils/ky'
import Store from '@/store'
import Events from '@/utils/events'
import { API } from '@/config'

export default {
	async loadUser(id) {
		let exist = Store.getters.loaded.users.has(id)
		if (exist) return

		let { data } = await http.get(API.USERS.get + id)
		if (!data || data.err) return Events.$emit('notification', data.err)

		Store.commit('updateInArray', { path: 'users', data: data })
		Store.commit('setLoaded', { path: 'users', id: data.id })
	},

	async loadPet(id) {
		let exist = Store.getters.loaded.pets.has(id)
		if (exist) return

		let { data } = await http.get(API.PETS.get + id)
		if (!data || data.err) return Events.$emit('notification', data.err)

		Store.commit('updateInArray', { path: 'pets', data: data })
		Store.commit('setLoaded', { path: 'pets', id: data.id })
	},

	async loadPets(ids) {
		if (!ids.length) return

		let exist = ids.filter(id => Store.getters.loaded.pets.has(id))
		if (exist.length === ids.length) return

		let { data } = await http.post(API.PETS.list, { ids })
		if (!data || data.err) return Events.$emit('notification', data.err)

		Store.commit('concatToArray', { path: 'pets', data: data })
		ids.forEach(id => Store.commit('setLoaded', { path: 'pets', id: id }))
	},

	async loadChat(id) {
		let { data } = await http.get(API.CHATS.get + id)
		if (!data || data.err) return

		Store.commit('updateInArray', { path: 'chats', data: data })
		return data
	},
}
